import {sum, mean, variance, min, max, median, extent} from 'd3-array';
import {ZeroDenominatorException} from './error';

const summarize = {sum, mean, variance, min, max, median, extent};
summarize.values = function (leaves) {
  return leaves;
};
summarize.count = function (leaves) {
  return leaves.length;
};

function dateComparator (order = 'ascending', field) {
  return function(a,b) {
    if (field) {
      a = a[field]; b = b[field];
    }
    if (order === 'natural') return 0;
    else if (order === 'ascending') return a.getTime() - b.getTime();
    else return b.getTime() - a.getTime();
  }
}

function comparator (order = 'ascending', orderList, textToNum = true, accessor = (d => d)) {
  //둘다 문자인 경우 
   // - 앞의 숫자 
  let reg = /(\d+((-|\.)*\d*))/;
  function __compareNumbers (a, b) {
    if (order === 'natural') return 0;
    else if (order === 'ascending') return a - b;
    else return b - a;
  }
  function __compareStrings (a, b, onlyText = false) {
    if (order === 'natural') return 0;
    if(textToNum && !onlyText) {
      let numA = a.match(reg), numB = b.match(reg);
      if (numA && numB) {
        return __compareNumbers (+numA[0], +numB[0]) || __compareStrings(a,b,true);
      } 
    }
    if (order === 'ascending') return a.localeCompare(b);
    return b.localeCompare(a);
  }
  function __compareByList (a, b) {
    let ai = orderList.indexOf(a); 
    let bi = orderList.indexOf(b);
    if (order === 'ascending') return ai - bi;
    else return bi - ai;
  }
  return function(a,b) {
    let compareFunc;
    if (!orderList || orderList.length === 0) {
      compareFunc = (typeof a === 'string' && typeof b === 'string' ? __compareStrings : __compareNumbers);
    } else {
      compareFunc = __compareByList;
    }
    return compareFunc(accessor(a),accessor(b));
  }
}

function stack (target, measures, mixed = false, normalized = false) {
  if(!Array.isArray(measures)) measures = [measures];
  target.forEach((d, i, arr) => {
    measures.forEach(m => {
      let prefix = m.field + (mixed ? '' : '-' + m.op);
      if (i === 0) d.data.value[prefix + '-start'] = 0;
      else d.data.value[prefix + '-start'] = arr[i-1].data.value[prefix + '-end'];
      d.data.value[prefix + '-end'] = d.data.value[prefix + '-start'] + d.data.value[prefix];
    })
  });
  if (normalized) {
    let max = {};
    let lastVal = target[target.length-1].data.value; // 이미 정렬이 되어있어야함
    measures.forEach(m => {
      let prefix = m.field + (mixed ? '' : '-' + m.op);
      max[prefix] = lastVal[prefix + '-end'];
    })
    target.forEach((d) => {
      measures.forEach(m => {
        let prefix = m.field + (mixed ? '' : '-' + m.op);
        let thisMax = max[prefix];
        if(thisMax !== 0) {
          d.data.value[prefix + '-start'] = d.data.value[prefix + '-start'] / thisMax;
          d.data.value[prefix + '-end'] = d.data.value[prefix + '-end'] / thisMax;
        } else {
          throw new ZeroDenominatorException(); //FIXME
        }
      })
    });
  }}  
export {
  comparator, 
  dateComparator,
  summarize, 
  stack
};


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/modules/transform.js